import {AddCouponApi, fetchAllCouponsApi} from '../api/coupon'
import {requestStarted,requestCompleted} from "./common"


export const setSaveCouponResponse =(response) => {
  return {
    type : "SET_SAVE_COUPON_RESPONSE",
    response
  }
}

export const RemoveCouponPropsData =(response) => {
  return {
    type : "SET_NULL_PROPS_RESPONSE",
    response
  }
}

export const setCouponDataList = (responseData) => {
  return{
    type : "SET_COUPONS_LIST",
    responseData
  }
}

export const createCouponView = () => {
  return{
    type : "VIEW_CREATE_COUPON"
  }
}

export const AddCouponData=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
      AddCouponApi(data).then((result) =>{
       dispatch(requestCompleted());
         dispatch(setSaveCouponResponse(result));
    });
  }
}

//fetchAllCoupons
export const fetchAllCoupons=(token) =>{
  return dispatch =>{
      dispatch(requestStarted());
      fetchAllCouponsApi(token).then((result) =>{
       dispatch(requestCompleted());
         dispatch(setCouponDataList(result));
    });
  }
}




// WEBPACK FOOTER //
// ./src/actions/coupon.js